import { Icon } from "../../components/Icon";
import { TLLink1 } from "./TLLink";

const EMAIL = "support@topleader.io";

export const EMAIL_SUBJECTS = {
  SIGN_IN: "SignIn",
  GET_HELP: "GetHelp",
  CAL_SYNC_FAILED: "Calendar Sync Failed",
  USER_ERROR_REPORT: "UserErrorReport",
  DEFAULT: "MessageFromTLPlatform",
};

/**
 * Sanitizes input by encoding potentially dangerous characters to prevent injection
 * while preserving all original content for mailto links.
 * @param {string} input - The input string to sanitize.
 * @returns {string} - The sanitized string with dangerous characters encoded.
 */
function sanitizeInput(input) {
  if (typeof input !== "string") return "";
  // Encode potentially dangerous characters to their HTML entity equivalents
  const encodeMap = {
    "&": "&amp;", // Prevents starting HTML entities or breaking partial tags in potential HTML contexts
    "<": "&lt;", // Prevents opening HTML tags, critical for avoiding injection in non-standard HTML-supporting clients
    ">": "&gt;", // Prevents closing HTML tags, to neutralize partial tags in potential HTML contexts
    // '"': '&quot;', // Prevents attribute injection in HTML tags, recommended for edge cases
    // "'": '&apos;', // Prevents single-quote attribute injection, recommended for consistency in edge cases
    // ';': '&#59;',  // Not critical: harmless in plain-text body after URL encoding, only relevant for non-standard params
    // '{': '&#123;', // Not critical: no risk in standard body, poses no threat to URL or HTML interpretation
    // '}': '&#125;', // Not critical: no risk in standard body, poses no threat to URL or HTML interpretation
    // '|': '&#124;'  // Not critical: no command injection risk in standard params like body
  };
  return input.replace(/[&<>"'{}|;]/g, (match) => encodeMap[match] || match); // Use || match to skip commented-out keys
}

/**
 * URL-encodes input for mailto compatibility, converting line breaks to %0D%0A.
 * @param {string} input - The input string to encode.
 * @returns {string} - The URL-encoded string.
 */
function encodeInput(input) {
  return encodeURIComponent(sanitizeInput(input)).replace(/%0A/g, "%0D%0A");
}

export const EmailTo = ({
  email = EMAIL,
  subject = EMAIL_SUBJECTS.DEFAULT,
  body,
  withIcon = false,
  sx = {},
}) => {
  return (
    <TLLink1
      href={`mailto:${email}?subject=${subject}&body=${encodeInput(body)}`}
      target="_blank"
      sx={sx}
    >
      {withIcon ? (
        <>
          <Icon name="MailOutline" sx={{ fontSize: "16px" }} />
          &nbsp;
        </>
      ) : (
        ""
      )}
      {email}
    </TLLink1>
  );
};
